export default __webpack_public_path__ + "static/media/Bg-lateral2.dec5f8b6.jpg";